import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from "../context/TranslationContext";
import '../styles/SelectLanguage.css';

import { ReactComponent as FlagPL } from '../resources/assets/flagPL.svg';
import { ReactComponent as FlagEN } from '../resources/assets/flagEN.svg';
import { ReactComponent as FlagDE } from '../resources/assets/flagDE.svg';
import { ReactComponent as FlagES } from '../resources/assets/flagES.svg';
import { ReactComponent as FlagAI } from '../resources/assets/flagAI.svg';

const SelectLanguage = ({onChange, language, onTranslateAI}) => {
  const { t } = useTranslation();
  const dropdownRef = useRef(null);
  const [selectedLanguage, setSelectedLanguage] = useState(language); 
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const languages = [
    { code: 'pl', name: t.language.Polish, flag: FlagPL },
    { code: 'en', name: t.language.English, flag: FlagEN },
    { code: 'de', name: t.language.German, flag: FlagDE },
    { code: 'es', name: t.language.Spanish, flag: FlagES },
    ...(onTranslateAI ? [{ code: 'ai', name: t.language.AITranslate, flag: FlagAI }] : [])
  ];

  const SelectedFlag = languages.find(lang => lang.code === selectedLanguage)?.flag;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  
  const handleLanguageChange = (code) => {
    setIsDropdownOpen(false);
    if(code==='ai') {
      if(onTranslateAI) {
        onTranslateAI();
      }
      return;
    }
    setSelectedLanguage(code);
    if(onChange) {
      onChange(code);
    }
  };

  return (
    <div className="select-language">
      <div className="select-language-flag" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
        {SelectedFlag && <SelectedFlag style={{ width: "auto", height: "var(--font-big)" }} />}
        <div className="select-language-arrow">{'>'}</div>
      </div>

      {isDropdownOpen && (
        <div className="select-language-dropdown" ref={dropdownRef}>
          {languages.map((lang) => (
            <div key={lang.code} className="select-language-option" onClick={() => handleLanguageChange(lang.code)}>
              <lang.flag style={{ width: "auto", height: "var(--font-big)", marginRight: '10px' }} />
              {lang.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectLanguage;